var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({ref:"vtextarea",staticClass:"j-textarea",attrs:{"color":_vm.color,"outlined":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [_vm._t("append")]},proxy:true}],null,true)},'v-textarea',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }